import { Container } from "@mui/system";
import React from "react";
import classes from "./Error.module.css";
import JA from "../utils/images/JA-logo.png";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <Container>
      <div className={classes.loginHead}>
        <img src={JA} alt="Journey Analytics" />
      </div>
      <div className={classes.ErrorText}>
        <h1>Oops!</h1>
        <p className={classes.errorCode}>Error 401</p>
        <br />
        <p>This error may occur due to the following reasons</p>
      </div>
      <div className={classes.listError}>
        {" "}
        <ul>
          <li>
            If you have signup using Google authentication, then you shouldn't
            use the same mail for local authentication which requires password{" "}
          </li>
          <li>This may occur due to Internal server error</li>
        </ul>
      </div>
      <p>Click here to go to login page</p>
      <Link to="/login">
        {" "}
        <Button
          sx={{ backgroundColor: "#1CB4C4", height: "3em" }}
          type="submit"
          variant="contained"
        >
          Login
        </Button>
      </Link>
    </Container>
  );
};

export default Error;
